import * as React from "react";
import { MessageCircle } from "lucide-react";

interface FloatingFeedbackButtonProps {
    formUrl?: string;
}

export const FloatingFeedbackButton: React.FC<FloatingFeedbackButtonProps> = ({
    formUrl = "https://chief-ring-8e8.notion.site/4d3181616ead4f43b0f1e39f209fbb1c?pvs=105",
}) => {

    const handleClick = () => {
        // Open in new tab safely
        window.open(formUrl, "_blank", "noopener,noreferrer");
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            className="
                fixed bottom-[34px] left-4 z-50
                inline-flex items-center gap-2
                rounded-full bg-emerald-600
                px-4 py-2.5 text-sm font-medium text-white
                shadow-lg shadow-black/40
                hover:bg-emerald-500
                focus:outline-none focus-visible:ring-2
                focus-visible:ring-emerald-400
                focus-visible:ring-offset-2
                focus-visible:ring-offset-slate-950
                transition
            "
            aria-label="Send feedback about ScopeShield"
        >
            <MessageCircle className="h-4 w-4" />
            <span className="hidden sm:inline">Send feedback</span>
            <span className="sm:hidden">Feedback</span>
        </button>
    );
};
